import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import Unit from './screens/index.vue';
const Unit = () => import('./screens/index.vue')

const clientUnitRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CLIENT_UNIT_VIEW,
    PERMISSIONS_KEYS.CLIENT_UNIT_EDIT,
  ])
) {
  clientUnitRoutes.push({
    path: '/regras-da-prescricao/unidades',
    name: 'Cadastro / Consulta|Unidade Cliente',
    component: Unit,
    meta: {
      icon: 'fa-hospital',
      requiresAuth: true,
    },
  });
}

export { clientUnitRoutes };
